if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        if (!this.form) return;

        this.variantIdInput.disabled = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.selectSizeText = this.querySelector(
          "p.pd-product-recommendation-item__select_size",
        );
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.inputs = this.querySelectorAll("input, select");
        this.resetSelection =
          this.hasAttribute("data-reset-selection") ?? false;

        if (this.submitButton.hasAttribute("disabled")) {
          this.inputs.forEach((input) => {
            input.addEventListener("change", this.onInputChange.bind(this));
          });
        }

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onInputChange() {
        this.submitButton.removeAttribute("disabled");
        this.selectSizeText?.classList?.add("hidden");
        this.submitButton.querySelectorAll("span").forEach((span, i) => {
          if (i === 0) {
            span.innerText = "Add to cart";
          } else if (i === 1) {
            span.innerText = "+";
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        const span = this.submitButton.querySelector("span");
        if (span?.textContent === "Added!") {
          this.submitButton.querySelectorAll("span").forEach((span, i) => {
            if (i === 0) {
              span.innerText = "Adding to Cart";
            } else if (i === 1) {
              span.innerText = "+";
            }
          });
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner")?.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        let url = routes.cart_add_url;
        if (this.form.action.includes("/cart/change")) {
          url = routes.cart_change_url;
        }

        fetch(`${url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            if (
              this.dataset?.sectionId &&
              this.dataset?.sectionId?.includes("pd_product_info")
            ) {
              const modal = document.querySelector(
                ".pd-product-recommendations-modal",
              );
              modal?.querySelector("summary")?.click();
            }

            this.submitButton.querySelectorAll("span").forEach((span, i) => {
              if (i === 0) {
                span.innerText = "Added!";
              } else if (i === 1) {
                span.innerText = "";
              }
            });

            if (this.resetSelection) {
              this.form.reset();
              this.selectSizeText?.classList?.remove("hidden");

              // Disable the submit button if there are multiple size options
              const sizeOptions = this.querySelectorAll(
                'fieldset.single-option-radio input[type="radio"]',
              );
              if (sizeOptions.length > 1) {
                this.submitButton.setAttribute("disabled", "disabled");
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner")?.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        this.parentElement.classList.toggle("error", errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
